module.exports = __webpack_public_path__ + "img/coming-soon.549b5f35.svg";